(() => {
  function updateFooterReviewScore(container = document) {
    container.querySelectorAll('.footer .jdgm-all-reviews-text__text').forEach((reviewText) => {
      const score = Number.parseFloat(reviewText.dataset.score);

      if (!Number.isFinite(score)) return;

      const truncatedScore = Math.floor(score * 10) / 10;
      reviewText.dataset.displayScore = truncatedScore.toFixed(1);
    });
  }

  async function recoverCarouselProductImage(image) {
    if (image.dataset.leceFallbackAttempted === 'true') return;
    image.dataset.leceFallbackAttempted = 'true';

    const productLink = image.closest('a[href*="/products/"]');
    if (!productLink) return;

    try {
      const productUrl = new URL(productLink.href, window.location.origin);
      const response = await fetch(`${productUrl.pathname}.js`);
      if (!response.ok) return;

      const product = await response.json();
      const featuredImage = product.featured_image || product.images?.[0];
      if (!featuredImage) return;

      const fallbackUrl = new URL(featuredImage, window.location.origin);
      fallbackUrl.searchParams.set('width', '112');
      const fallbackSource = fallbackUrl.toString();

      image.removeAttribute('srcset');
      image.dataset.src = fallbackSource;
      image.dataset.srcRetina = fallbackSource;
      image.src = fallbackSource;
    } catch {
      return;
    }
  }

  function recoverExistingCarouselImages(container = document) {
    container.querySelectorAll('.jdgm-carousel-item__product-image').forEach((image) => {
      if (image.complete && image.naturalWidth === 0 && image.currentSrc) recoverCarouselProductImage(image);
    });
  }

  document.addEventListener(
    'error',
    (event) => {
      if (event.target.matches?.('.jdgm-carousel-item__product-image')) recoverCarouselProductImage(event.target);
    },
    true
  );

  document.addEventListener(
    'DOMContentLoaded',
    () => {
      updateFooterReviewScore();
      recoverExistingCarouselImages();
    },
    { once: true }
  );
  document.addEventListener('shopify:section:load', (event) => {
    updateFooterReviewScore(event.target);
    recoverExistingCarouselImages(event.target);
  });
})();
